import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const myApplicationsRoute: RouteConfig<'with-page'> = {
    name: 'My Applications',
    path: '/work-opps/my-applications',
    page: lazy(() => import('.')),
    context: 'member',
    flags: ['member-route'],
    permissions: ['workOps'],
}
